import { useFormikContext } from "formik";
import { useState } from "react";
import { useTranslation } from "react-i18next";
interface IProductFeaturesProps {
  productKey: string;
  priceType?: string;
  productInfo: any;
}
const ProductFeatures = ({
  productKey,
  priceType = "premium",
  productInfo,
}: IProductFeaturesProps) => {
  const [toggleMoreInfoOn, setToggleMoreInfoOn] = useState<boolean>(false);
  const { t } = useTranslation();
  const toggleMoreInfo = () => {
    setToggleMoreInfoOn((prev) => !prev);
  };
  // console.log("detailBox", priceType);
  return (
    <>
      {/* {Array.from(Array(productInfo.featuresCnt - 1).keys()) */}

      {Array.from(Array(3).keys())
        .filter(
          (item2, index2) =>
            (!toggleMoreInfoOn && index2 < 3) || toggleMoreInfoOn
        )
        .map((item, index1) => (
          <div className="text text--lg mg mb-16" key={index1}>
            <i className="icon_check_info inline-block vertical-middle" />
            <span className="terms inline-block vertical-middle mg ml-10 text text--14">
              {t(
                "subscriptionType.terms." +
                  productKey +
                  "." +
                  priceType +
                  "_" +
                  (index1 + 1)
              )}
            </span>
          </div>
        ))}

      {/* {productInfo.featuresCnt > 3 && (
        <div className="text text--lg mg mb-16">
          <a className="cursor-pointer" onClick={() => toggleMoreInfo()}>
            <i
              className={`${
                toggleMoreInfoOn ? "icon_minus_green" : "icon_plus_green"
              } inline-block vertical-middle`}
            />
            <span className="inline-block vertical-middle mg ml-10 text text--green">
              {priceType &&
                priceType !== "" &&
                t(
                  "siteType." +
                    priceType +
                    ".orderSpecification." +
                    (toggleMoreInfoOn ? "hide" : "showMore")
                )}
            </span>
          </a>
        </div>
      )} */}
    </>
  );
};

export default ProductFeatures;
